/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type TodosWidgetContainer_user$ref: FragmentReference;
export type TodosWidgetContainer_user = {|
  +id: string,
  +$refType: TodosWidgetContainer_user$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "TodosWidgetContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '1add81b6529f0c97903c0d0f28d9af8e';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Widget/Widgets/Todos/__generated__/TodosWidgetContainer_user.graphql.js